<div class="tabs-container">
    <div class="tab-wrapper-{{ tabs.length }}" *ngFor="let tab of tabs">
        <div class="tab" [ngClass]="{ selected: tab.index === selectedTabIndex && tabs.length > 1 }" (click)="tabClicked(tab)">
            <a [ngClass]="{ bold: tabs.length === 1 }"
                >{{ tab.tabName }} <span class="has-value" *ngIf="tab.hasValue && tab.index !== selectedTabIndex"></span
            ></a>
        </div>
    </div>
</div>
<div class="popper-selected-tab-content">
    <div *ngIf="selectedTabIndex === typesMap.Auto">
        <ms-my-bets-earlypayout-autocashout
            class="auto-cashout-info"
            [ngClass]="{ 'auto-cashout-info--visible': !isAutoCashoutSet }"
            [betNumbers]="betNumbers"
            [type]="typesMap.Auto"
            [betTypeInfo]="betTypeInfo"></ms-my-bets-earlypayout-autocashout>
        <ms-my-bets-earlypayout-remove-autocashout
            class="auto-cashout-info"
            [ngClass]="{ 'auto-cashout-info--visible': isAutoCashoutSet }"
            [betNumbers]="betNumbers"
            [type]="typesMap.Auto"
            [betTypeInfo]="betTypeInfo"></ms-my-bets-earlypayout-remove-autocashout>
    </div>
    <div *ngIf="selectedTabIndex === typesMap.Notify">
        <ms-my-bets-earlypayout-autocashout
            class="auto-cashout-info"
            [ngClass]="{ 'auto-cashout-info--visible': !isAutoCashoutSet }"
            [betNumbers]="betNumbers"
            [type]="typesMap.Notify"
            [betTypeInfo]="betTypeInfo"></ms-my-bets-earlypayout-autocashout>
        <ms-my-bets-earlypayout-remove-autocashout
            class="auto-cashout-info"
            [ngClass]="{ 'auto-cashout-info--visible': isAutoCashoutSet }"
            [betNumbers]="betNumbers"
            [type]="typesMap.Notify"
            [betTypeInfo]="betTypeInfo"></ms-my-bets-earlypayout-remove-autocashout>
    </div>
</div>
